import AnimeList from "./AnimeList";
import Animecard from "./Animecard";

function App() {
  return (
    <>
      <AnimeList />
    </>
  );
}

export default App;
